"use strict";

module.exports = require("./is-implemented")() ? Array.from : require("./shim");



//////////////////
// WEBPACK FOOTER
// D:/cpc/sinocc.web/web.X6/www/x6.ng2/~/es5-ext/array/from/index.js
// module id = ../../../../es5-ext/array/from/index.js
// module chunks = 4